<div [formGroup]="parentFormGroup" class="form-container">
  <mat-form-field appearance="outline" class="form-date">
    <mat-label i18n>Start date</mat-label>
    <input matInput [matDatepicker]="bookingDateStart" id="booking-date-start-date" formControlName="startDate">
    <mat-datepicker-toggle matSuffix [for]="bookingDateStart"></mat-datepicker-toggle>
    <mat-datepicker #bookingDateStart></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline" class="form-hour">
    <mat-label i18n>Hour</mat-label>
    <mat-select id="booking-date-start-hour" formControlName="startHour">
      @for (option of hourNames; track option) {
        <mat-option [value]="option.id">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="form-minute">
    <mat-label i18n>Minute</mat-label>
    <mat-select id="booking-date-start-minute" formControlName="startMinute">
      @for (option of minuteNames; track option) {
        <mat-option [value]="option.id">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
